import ProductGridItem from './ProductGridItem';
import { SearchForm } from './SearchForm';
import jQuery from 'jquery';
export default class StaticSearch {
    constructor(section) {
        this.section = section;
        this.$el = jQuery(section.el);
        this.$searchField = this.$el.find('[data-live-search]'); // Product items
        this.productItems = [];
        const $productItems = this.$el.find('[data-product-item]');
        $productItems.each((i, productItem) => {
            this.productItems.push(new ProductGridItem({
                el: productItem,
                id: this.section.id,
                lazy: true,
            }));
        });
        this.searchForm = new SearchForm(this.$searchField[0]);
    }
    onSectionUnload() {
        this.searchForm.unload();
        this.productItems.forEach((productItem) => {
            productItem.unload();
        });
    }
}
